import defaultTheme from '../../themes/defaultTheme';
export const defaultTenant = {
    value: '00000000-0000-0000-0000-000000000000',
    label: 'Dummy',
    name: 'dummy',
    theme: "defaultTheme",
    platform: 'RC',
};
export const tenants = [
    {
        value: 'a768fdb3-d9da-4f97-b1a9-bb576c4b8c4c',
        label: 'Amazon',
        name: 'amazon',
        theme: "amazonTheme",
        platform: 'RC',
    },
    {
        value: '81ab2e18-ba72-488f-a6fc-1e51c3e97793',
        label: 'American Eagle',
        name: 'aeoutfitters',
        theme: "americanEagleTheme",
        platform: 'RC',
    },
    {
        value: 'df91b23a-9784-4343-b76e-797b2d13ea53',
        label: 'Athleta',
        name: 'athleta',
        theme: "athletaTheme",
        platform: 'RC',
    },
    {
        value: 'aebf16f9-4005-4f5c-9153-298c1ef1c5a3',
        label: 'At Home',
        name: 'athome',
        theme: "atHomeTheme",
        platform: 'RC',
    },
    {
        value: '85f25104-b2f0-41a3-9d6b-65e1420540fe',
        label: 'Banana Republic',
        name: 'br',
        theme: "bananaRepublicTheme",
        platform: 'RC',
    },
    {
        value: 'a8dda620-1bf3-44e0-84dd-f1d11c239a43',
        label: 'Belk',
        name: 'belk',
        theme: "belkTheme",
        platform: 'RC',
    },
    {
        value: '87b9d124-a021-4f1c-8711-663b839d5cd3',
        label: 'BNPL',
        name: 'bnpl',
        theme: "bnplTheme",
        platform: 'BNPL',
    },
    {
        value: '43d2c366-699a-4311-95e8-f2f99bda7b77',
        label: 'BP',
        name: 'bp',
        theme: "bpTheme",
        platform: 'RC',
    },
    {
        value: '597246f5-3e98-49f8-9c53-53bc38c31433',
        label: 'Cathay',
        name: 'cathay',
        theme: "cathayTheme",
        platform: 'RC',
    },
    {
        value: 'e28967e0-a0c4-47c1-b60a-266fa42d0276',
        label: 'CheapOAir',
        name: 'cheapoair',
        theme: "cheapOAirTheme",
        platform: 'RC',
    },
    {
        value: '3f17837b-eee7-4b4f-ad37-c160af60dba4',
        label: 'Crate and Barrel',
        name: 'cb',
        theme: "crateAndBarrelTheme",
        platform: 'RC',
    },
    {
        value: '767e3c14-a145-45c1-a67c-88ac3a01a489',
        label: 'eBayCB',
        name: 'ebaycb',
        theme: "eBayCBTheme",
        platform: 'RC',
    },
    {
        value: 'cd6f70a0-6980-455c-83d3-d25d9a8e947b',
        label: 'Gap',
        name: 'gap',
        theme: "gapTheme",
        platform: 'RC',
    },
    {
        value: '82344a2a-8b70-4b14-9902-4b4b07272d97',
        label: 'Google',
        name: 'google',
        theme: "googleTheme",
        platform: 'RC',
    },
    {
        value: 'ca25442f-67f9-49f9-b97a-b2b676ab2b90',
        label: 'Harbor Freight',
        name: 'hft',
        theme: "harborFreightTheme",
        platform: 'RC',
    },
    {
        value: '2d0f953f-35fa-425e-b2d5-7420c822a0cc',
        label: 'HSN',
        name: 'hsn',
        theme: "hsnTheme",
        platform: 'RC',
    },
    {
        value: '1c469a00-73c2-49f5-96cd-130853c3babe',
        label: 'Infiniti',
        name: 'infiniti',
        theme: "infinitiTheme",
        platform: 'RC',
    },
    {
        value: '2dd36679-45ab-4561-965f-754dd2cd2fa5',
        label: 'JCrew',
        name: 'jcrew',
        theme: "jcrewTheme",
        platform: 'RC',
    },
    {
        value: 'b020e047-035c-4277-814c-e046ad2bf324',
        label: 'JCPennys',
        name: 'jcpenney',
        theme: "jcPennysTheme",
        platform: 'RC',
    },
    {
        value: '54165421-a738-413d-ae7f-0c0df1dc87b9',
        label: 'Lowes',
        name: 'lowes',
        theme: "lowesTheme",
        platform: 'RC',
    },
    {
        value: 'b65012f5-7d0f-497f-9a00-2738ba1056cf',
        label: 'Marvel',
        name: 'marvel',
        theme: "marvelTheme",
        platform: 'RC',
    },
    {
        value: 'f36861a8-cc61-4e86-b8ff-166c9330f735',
        label: 'Nissan',
        name: 'nissan',
        theme: "nissanTheme",
        platform: 'RC',
    },
    {
        value: '9162fbb9-6f26-4784-b7a5-6fe75688f299',
        label: 'Norwegian Reward',
        name: 'norair',
        theme: "norwegianRewardTheme",
        platform: 'RC',
    },
    {
        value: 'c52ae765-24cc-4683-be21-059236983994',
        label: 'OldNavy',
        name: 'oldnavy',
        theme: "oldNavyTheme",
        platform: 'RC',
    },
    {
        value: '40b51dfe-c612-4626-b207-742278c3ed7f',
        label: 'OneTravel',
        name: 'onetravel',
        theme: "oneTravelTheme",
        platform: 'RC',
    },
    {
        value: '92301220-4cb6-43ec-b6f3-d06120f59645',
        label: 'Paypal',
        name: 'paypal',
        theme: "paypalTheme",
        platform: 'RC',
    },
    {
        value: '7e632587-f54b-40e2-acc3-9cd9bfeb8f33',
        label: 'PayPalCredit',
        name: 'paypalcredit',
        theme: "payPalCreditTheme",
        platform: 'RC',
    },
    {
        value: 'adfc20cc-10de-4e04-aa31-d878fc1e4fa5',
        label: 'PSCC',
        name: 'pscc',
        theme: "psccTheme",
        platform: 'PSCC',
    },
    {
        value: 'cc0a2345-7632-447f-aeb6-3f1180394dc6',
        label: 'CareCredit',
        name: 'carecredit',
        theme: "careCreditTheme",
        platform: 'PSCC',
    },
    {
        value: 'f1fe3549-6761-4b39-9724-cb74f726c354',
        label: 'QVC',
        name: 'qvc',
        theme: "qvcTheme",
        platform: 'RC',
    },
    {
        value: 'f1f4a3e4-eb62-4363-b847-67626aa5d5ce',
        label: 'Rakuten',
        name: 'ebates',
        theme: "rakutenTheme",
        platform: 'RC',
    },
    {
        value: '76615a32-249d-46f5-aa16-f8c42b13ccbf',
        label: 'RewardsOfSport',
        name: 'dicks',
        theme: "rewardsOfSportTheme",
        platform: 'RC',
    },
    {
        value: '4a5d29e4-81ed-42ff-82a0-45675f76e272',
        label: "Sam's Club",
        name: 'sams',
        theme: "samsClubTheme",
        platform: 'RC',
    },
    {
        value: '7834fda9-3749-427f-9357-4ee8c8d35096',
        label: 'ShopHQ',
        name: 'shopnbc',
        theme: "shopHQTheme",
        platform: 'RC',
    },
    {
        value: 'ae87d9ca-9c1d-4bd1-8fd3-e95fccb5cf6e',
        label: 'Synchrony Mastercard (TRU Converted Accounts) ',
        name: 'tru',
        theme: "syfMastercardTheme",
        platform: 'RC',
    },
    {
        value: '3a6d4222-f83a-41bf-bb7f-7bb0fe01bc24',
        label: 'synchrony',
        name: 'synchrony',
        theme: "synchronyTheme",
        platform: 'RC',
    },
    {
        value: '2d0a22fb-dc62-4589-a5b6-a19869b8c8f3',
        label: 'TJMax',
        name: 'tjx',
        theme: "tjMaxTheme",
        platform: 'RC',
    },
    {
        value: '1d3f9429-ee11-4383-9e27-51fec4f0d567',
        label: 'Verizon',
        name: 'verizon',
        theme: "verizonTheme",
        platform: 'RC',
    },
    {
        value: 'f99b3bbb-4be1-4237-8084-5ad61c3be02d',
        label: 'Walgreens',
        name: 'walgreens',
        theme: "walgreensTheme",
        platform: 'RC',
    },
    {
        value: '69580590-60dc-4f5e-ba9b-9f3d47f9b019',
        label: 'Venmo',
        name: 'venmo',
        theme: "venmoTheme",
        platform: 'RC',
    },
    {
        value: '07919fa6-c672-4918-8461-3955a20b5c58',
        label: 'Virgin',
        name: 'virgin',
        theme: "virginTheme",
        platform: 'RC',
    },
    {
        value: '9947c962-c910-4cc3-86c7-97d6b58232da',
        label: 'Zulily',
        name: 'zulily',
        theme: "zulilyTheme",
        platform: 'RC',
    },
    {
        value: '89775e54-f0c1-44b0-99a1-b9f21a466232',
        label: 'BNPLMonthlyLoan',
        name: 'bnplmonthlyloan',
        theme: "bnplTheme",
        platform: 'BNPL',
    },
    {
        value: '7add153b-ac2c-476f-ace7-4a4f4e028925',
        label: 'onepaywalmart',
        name: 'onepaywalmart',
        theme: "onepaywalmartTheme",
        platform: 'RC',
    },
    {
        value: '30fc67aa-0579-4743-9abc-b3a088540b53',
        label: 'Sun Country',
        name: 'suncountry',
        theme: "sunCountryTheme",
        platform: 'RC',
    },
];
export function getTenantByAccessKey(accessKey) {
    return tenants.find((val) => accessKey && val.value === accessKey.trim());
}
export function getTenantByName(name) {
    return tenants.find((val) => val.name === name.toLowerCase());
}
export function isPSCCTenant(tenant) {
    return tenant.name === 'pscc';
}
export function isBNPLTenant(tenant) {
    return tenant.name === 'bnpl';
}
let tenantThemes = Promise.resolve(undefined);
if (!process.env.REACT_APP_VISTA_PLATFORM) {
    tenantThemes = import('./TenantThemes').then((themeModule) => themeModule.default);
}
export const getTheme = (name) => {
    return tenantThemes.then(t => (t && t[name]) || defaultTheme);
};
